<template>
  <div :class="'accordion-item' + (active ? ' active' : '')">
    <a href="#" class="flex justify-between" @click.prevent="active = !active">
      <div class="accordion_header">
        <span class="heading pt-2" v-html="title"/>
        <div class="icon-wrapper">
          <i v-if="!active" class="mdi mdi-plus-box-outline"></i>
          <i v-else class="mdi mdi-minus-box-outline"></i>
        </div>
      </div>
    </a>
    <div class="accordion_content p-2" v-show="active">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  props: [
    'title'
  ],
  data() {
    return {
      active: false,
    }
  },
}
</script>

<style scoped lang="scss">
@import '../../sass/variables_mixins';

.accordion_header {
  width: 100%;
  box-shadow: 0 0 10px 0 #c8c8c8;
  min-height: 80px;
  margin-bottom: 20px;
  padding: 20px;
  float: left;
  position: relative;
}

.accordion_content {
  padding: 20px;
}

a, a:hover {
  color: $dark-blue;
  text-decoration: none;
}

.icon-wrapper {
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 20px;
}

.heading {
  float: left;
  max-width: 80%;
}
</style>

